















































import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import BasePicture from "@/components/Base/BasePicture";
import LandingCreatorsButton from "./LandingCreatorsButton.vue";

export default defineComponent({
  name: "LandingCreatorsWhyJoin",
  components: { BasePicture, LandingCreatorsButton },
  setup() {
    const items = computed(() => [
      {
        icon: "/img/landingCreators/icons/profile.svg",
        title: $t("Showcase your profile"),
        text: $t("Build a unique profile to present your content."),
      },
      {
        icon: "/img/landingCreators/icons/wallet.svg",
        title: $t("Monetize your work"),
        text: $t("Earn through subscriptions, pay-per-view, and fan engagement."),
      },
      {
        icon: "/img/landingCreators/icons/grow-up.svg",
        title: $t("Grow with creator tools"),
        text: $t("Use platform tools to manage your audience and grow your brand."),
      },
      {
        icon: "/img/landingCreators/icons/gears.svg",
        title: $t("Stay in full control"),
        text: $t("You choose what you post, within platform guidelines."),
      },
    ]);

    return {
      items,
    };
  },
});
